import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  useMediaQuery,
  useSmOrMdScreenMediaQuery,
} from "@/react/hooks/useMediaQuery";
import { useHelpWidgetContext } from "../context/HelpWidgetContext";
import { useHelpWidgetRoutes } from "../hooks/useHelpWidgetRoutes";
import { pushLocation } from "../utils/locationHistoryManager";

const FULL_SCREEN_AVAILABLE_PATHS = [
  "/form",
  "/posts/",
  "/news/",
  "/message_confirmation/",
  "/conversations/",
] as const;

interface RecentLocationWrapperProps {
  children: React.ReactNode;
}

const isFullScreenAvailableOnPath = (pathname: string): boolean =>
  FULL_SCREEN_AVAILABLE_PATHS.some(path =>
    path.endsWith("/") ? pathname.startsWith(path) : pathname === path,
  ) || pathname.endsWith("/new_ticket");

export const RecentLocationWrapper = ({
  children,
}: RecentLocationWrapperProps): JSX.Element => {
  const { isConversationsRoute } = useHelpWidgetRoutes();
  const isMobile = useSmOrMdScreenMediaQuery();
  const isLargeScreen = useMediaQuery("(min-width: 1080px)");
  const location = useLocation();
  const { collapseWidget, collapseSideBar, isShowingLeaveWarning } =
    useHelpWidgetContext();

  useEffect(() => {
    pushLocation(location.pathname);

    const shouldCollapseWidget =
      !isFullScreenAvailableOnPath(location.pathname) ||
      isShowingLeaveWarning ||
      isMobile;

    if (shouldCollapseWidget) {
      collapseWidget();
    }

    if (!isConversationsRoute || !isLargeScreen) {
      collapseSideBar();
    }
  }, [
    location.pathname,
    collapseWidget,
    collapseSideBar,
    isConversationsRoute,
    isShowingLeaveWarning,
    isMobile,
    isLargeScreen,
  ]);

  return <>{children}</>;
};
